import { render, staticRenderFns } from "./TwoFactorAuthenticationModals.vue?vue&type=template&id=eb520b2e"
import script from "./TwoFactorAuthenticationModals.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports